module.exports = __webpack_public_path__ + "img/music-on.aee70686.jpg";